import {
  FDBox, FDStack, FDTextButton,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { buildClientLink } from 'Views/Page/Content/Templates';
import { dataAttrs } from 'Helpers/Testing';
import React from 'react';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';
import metaOverrideSet from './MetaOverrideSet';

export const InfoBoxError = (props) => {
  const { resource } = props;

  if (!resource.attr('errorMessage')) {
    return null;
  }

  return (
    <FDBox paddingY={1}>
      <FDStack direction={'column'} alignItems={'flex-start'} spacing={1}>
        <MetaControl resource={resource} metaOverrideSet={metaOverrideSet} attrName={'errorMessage'} />
        {resource.withRelationship(
          fr.relationships.navigate.name,
          (rel) => (
            <FDTextButton
              label={rel.meta('prompt') || 'Update'}
              href={buildClientLink(rel.link('related'))}
              icon={'edit'}
              {...dataAttrs('create-your-plan-action-button')}
            />
          ),
          () => null,
        )}
      </FDStack>
    </FDBox>
  );
};

InfoBoxError.defaultProps = {
};

InfoBoxError.propTypes = {
  resource: PropTypes.object.isRequired,
};
